import * as React from "react";
const SvgFiRrScale = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scale_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-2.539A5.9 5.9 0 0 0 10.8.117 5.76 5.76 0 0 0 7.589 2H5a5.006 5.006 0 0 0-5 5v12a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5V7a5.006 5.006 0 0 0-5-5m-7 0a4 4 0 0 1 4 4 1 1 0 0 1-1 1h-2.132l.964-1.445a1 1 0 0 0-1.664-1.11L10.465 7H9a1 1 0 0 1-1-1 4 4 0 0 1 4-4m10 17a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.393c-.26.71-.392 1.46-.393 2.215A2.79 2.79 0 0 0 8.785 9h6.43A2.76 2.76 0 0 0 18 6.353 7.6 7.6 0 0 0 17.656 4H19a3 3 0 0 1 3 3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scale_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScale;
